import { Container, Image } from 'react-bootstrap';
import Slider from 'react-infinite-logo-slider';
import abovo from '../images/abovo.png';
import excento from '../images/excento.png';
import innova from '../images/innova.png';
import pg from '../images/pg.png';
import sanicom from '../images/sanicom.png';
import re_cruiter from '../images/re-cruiter.png';
import worksol from '../images/worksol.png';
import successful_people from '../images/successful_people.png';
import ewc from '../images/ewc.png'
import atile from '../images/atlie.png'
import { useState, useEffect } from 'react';


function Partners() {

    const [content, setContent] = useState(null);

    useEffect(() => {
        fetch("/data/content.json")
            .then((res) => res.json())
            .then((data) => setContent(data))
            .catch((error) => console.error("Error loading JSON:", error));
    }, []);


    if (!content) return <div></div>;

    const { partners } = content;

    return (
        <>
            <Container className='text-center' style={{ paddingTop: '10px', paddingBottom: '0', marginTop: '-80px' }}>
                <p style={{ 
                    fontSize: '20px', 
                    color: '#9ca3af',
                    marginBottom: '30px',
                    fontWeight: '500',
                }}>
                    {partners.title}:
                </p>
            </Container>

            <Container fluid className='partners-slider' style={{ marginTop: '-20px' }}>
                <Slider
                    duration={80}
                    blurBorders={true}
                >
                    <Slider.Slide className="partners-slide">
                        <Image src={abovo} alt="abovo" className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={re_cruiter} alt='re-cruiter' className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={worksol} alt='worksol' className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={excento} alt='excento' className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={innova} alt='innova' className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={pg} alt='pg' className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={sanicom} alt='sanicom' className='w-36' />
                    </Slider.Slide>

                    <Slider.Slide className="partners-slide">
                        <Image src={successful_people} alt='successful_people' className='w-36' />
                    </Slider.Slide>
                    
                    <Slider.Slide className="partners-slide">
                        <Image src={ewc} alt='ewc' className='w-36' />
                    </Slider.Slide>
                    
                    <Slider.Slide className="partners-slide">
                        <Image src={atile} alt='atile' className='w-36' />
                    </Slider.Slide>
                </Slider>
            </Container>
        </>
    );
}

export default Partners;